export const defaultVocabulary = {
  site: {
    Sg_main: "site",
    Pl_main: "sites",
  },
};

export type Vocabulary = "Sg_main" | "Pl_main";
